<div class="app-icon-name-desc">
	<div class="app-icon-name-desc__icon" [style.background]="color()">
		@if (iconText()) {
		<span>{{ iconText() }}</span>
		} @else {
		<app-icon [icon]="icon()" [color]="iconColor()" [width]="iconWidth()" [height]="iconHeight()" />
		}
	</div>

	<div class="app-icon-name-desc__content" [class]="fontSize()">
		<strong>{{ title() }}</strong>
		<span>{{ description() }}</span>
	</div>
</div>
